import load from "@/conf/js/load";
import Vue from "vue";

import "../../assets/style/base.min.css"
import "../../assets/style/fancy.min.css"
// import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
// import 'vue2-datepicker/locale/zh-cn';
export  default  {


    html (that , type) {

        load.css(that.tpl.css_path)

        const component = Vue.extend({
            template: that.tpl.html,
            // components: { DatePicker },
            data: function () {
                return {
                    field: that.tpl.field
                }
            },
            created() {
                this.$nextTick(()=>{
                    this.computerSize(type)
                })
            },
            methods: {

                /**
                 * 响应式
                 */
                computerBoxSize() {
                    let container = document.getElementsByClassName("pf");
                    let width = 0, height = 0, style = null;
                    for (let element of container) {
                        style = window.getComputedStyle(element);
                        height += parseInt(style.height.replace("px", ""));
                        width = parseInt(style.width);
                    }

                    let clientWidth = document.body.clientWidth;
                    let scale = clientWidth / width;
                    if (scale < 1) {
                        document.getElementById("page-container").style.width = width + 'px';
                        document.getElementById("page-container").style.height = height + 'px';
                        document.getElementById("page-container").style.transform = "scale(" + scale + ")"
                        document.getElementById("page-container").style.transformOrigin = "0 0"
                        document.getElementById("page-container").style.overflow = "hidden"
                    }


                },
                /**
                 *  获取文字宽度
                 * @param element
                 * @returns {number}
                 */
                getTxtWidth(element) {
                    let span = document.createElement("span");
                    span.className = "loading-start-public-bg";
                    span.textContent = "_";
                    span.style.visibility = "hidden";
                    span.style.fontSize = window.getComputedStyle(element.parentElement).fontSize;
                    let ibj =  element.parentElement.appendChild(span);
                    let width = ibj.offsetWidth;
                    span.parentNode.removeChild(span);
                    return parseInt(width);
                },
                /**
                 * 计算input尺寸
                 */
                computerSize(type) {
                    setTimeout(() => {
                        let elements = document.querySelectorAll('#page-container input');
                        for (let element of elements) {

                            //设置上级index
                            element.parentElement.style.zIndex = 9
                            //如果上级不是div
                            if (element.parentElement.tagName!=="DIV")
                                element.parentElement.parentElement.style.zIndex = 8

                            let maxWidth = this.getTxtWidth(element) * (parseInt(element.getAttribute("data-num")) + 2);

                            if (maxWidth>50)
                            {
                                // element.style.maxWidth = maxWidth + 'px'
                                element.style.width = maxWidth + 'px'
                            }
                            element.style.fontSize = window.getComputedStyle(element.parentElement).fontSize

                            //如果不是系统填写的
                            if (element.getAttribute("class")!=="v31_fill_input_sys")
                                element.style.background = "#f7bbbbad"

                            if (type==="settings")
                                 element.style.cursor = "pointer"
                            element.style.border = "none"
                            element.style.borderRadius = "6px"
                        }

                        this.computerBoxSize()
                        this.computerClassName("mx-datepicker")
                    }, 200)

                },
                /**
                 * 计算classname  z index
                 */
                computerClassName(className) {
                    setTimeout(() => {
                        let elements = document.getElementsByClassName(className);
                        for (let element of elements) {
                            element.parentElement.style.zIndex = 9
                        }
                    }, 200)
                },
                /**
                 * 设置
                 * @param e
                 * @param id
                 */
                settings(e, id) {
                    console.log(id)
                    that.fieldId = id
                }
            }
        })
        that.tplComponent = new component().$mount('#tpl_content')
    }


}
